import React from "react";
import MapImage from "../../../assets/map2.png";
import { useSpring, animated } from "react-spring";
import useOnScreen from "../../../hooks/useOnScreen";

const ContactUs: React.FC = () => {
  const [isAnimated, setAnimated] = React.useState(false);
  const ref = React.useRef<HTMLDivElement>(null);
  const isVisible = useOnScreen(ref, "-100px");

  const fadeIn = useSpring({
    opacity: isAnimated ? 1 : 0,
    config: { duration: 1500 }, // Adjust the duration (in milliseconds) to your preference
  });

  React.useEffect(() => {
    if (isVisible) {
      setAnimated(true);
    }
  }, [isVisible]);

  return (
    <animated.div
      ref={ref}
      style={fadeIn}
      className="container mx-auto text-center p-8"
    >
      <h2 className="text-3xl font-bold lg:text-5xl text-palette1 mb-8">
        Contact Us
      </h2>
      <p className="text-xl 2xl:text-2xl text-palette3 mb-12 ">
        We'd love to hear from you! Reach out to us for inquiries,
        collaborations, or any questions you may have
      </p>
      <div className="flex flex-col lg:flex-row text-center justify-center items-center mb-8">
        <div className="lg:w-1/2">
          <p className="text-xl font-medium text-palette1 mb-4 mt-16 sm:mt-0">
            Visit Us:
          </p>
          <div className="flex justify-center gap-8 items-center mb-4">
            <p className="text-palette3 mb-4">
              <span className="font-medium text-palette1">Legal Office</span>
              <br />
              Dream Innovation Srl
              <br />
              Via F. Parri, 1
              <br />
              Sant'Arpino (CE), 81030
              <br />
            </p>

            <p className="text-palette3 mb-4">
              <span className="font-medium text-palette1">Working Site</span>
              <br />
              Regus - Naples
              <br />
              Via Benedetto Brin, 63/Piano 2
              <br />
              Napoli (NA), 80142
              <br />
            </p>
          </div>

          <p className="text-xl font-medium text-palette1 mb-2">Email Us:</p>
          <p className="text-palette3 mb-4">info@dreaminnovation.it</p>
        </div>
        <img
          src={MapImage} // Replace with the actual path to your image
          alt="Google Maps Location"
          className="lg:w-1/2 lg:mr-8 rounded-md shadow-md"
        />
      </div>
    </animated.div>
  );
};

export default ContactUs;
